<template>
  <page-view :is-loading="firstFetch">
    <template #header>
      <base-header :title="$t('message.safety')" :menu="pageMenu" />
    </template>

    <template #content>
      <add-domains :userLibrary="userLibrary" @addDomains="addDomainsToArray" />
      <confirm-remove-domains />
      <template v-if="errors.noLibraryError || errors.getRefers">
        <v-card
          class="d-flex align-center justify-center"
          flat
          min-height="400px"
          color="background"
        >
          <v-row no-gutters justify="center" align="center">
            <v-col cols="8" class="d-flex justify-center align-center mb-3">
              <span class="text-h5">{{
                $t('message.pages.folderSettings.errorOnFetch')
              }}</span>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters align="center" justify="center">
                <v-btn
                  color="primary"
                  class="ma-2 ml-3 white--text"
                  rounded
                  @click="getUserInfos"
                >
                  <span class="mx-2">{{ $t('message.tryAgain') }}</span>
                  <v-icon right dark> mdi-cached </v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </template>

      <template v-else>
        <v-card flat min-height="400px" color="background">
          <v-row no-gutters>
            <v-col cols="12" class="mt-6">
              <v-row align="center" no-gutters>
                <span class="pageTitle mb-2">
                  {{ $t('message.pages.folderSettings.allowedDomains') }}
                </span>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row align="center" justify="start" no-gutters>
                <v-col cols="12">
                  <p
                    class="helpTexts mb-7"
                    v-html="
                      $t('message.pages.folderSettings.helpTexts.line_1a')
                    "
                  />
                </v-col>
                <v-col
                  v-if="hasEditAllowedDomains"
                  cols="12"
                  :data-intro="$t('message.introJS.domain.add')"
                >
                  <v-row>
                    <v-col class="d-flex" style="margin: 4px 0 0.8rem 0">
                      <v-switch
                        v-model="changeDomainVerification"
                        class="mx-1"
                        :key="domainVerificationKey"
                        style="margin: 0; padding: 0"
                        inset
                        :disabled="!hasEditAllowedDomains"
                        @click="confirmRemoveValidation"
                        hide-details
                      >
                        <template v-slot:label>
                          <span class="helpTexts">
                            {{
                              $t(
                                'message.pages.folderSettings.activeAllowedDomains'
                              )
                            }}
                          </span>
                        </template>
                      </v-switch>
                      <LearnMoreBtn
                        :onClickBtn="() => handleGoToArticle()"
                        customClass="ask__btn--tiny"
                        customStyle="margin-top: -2px"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-row
                  :class="{ 'toggle-config-visibility': !blockNoneRefer }"
                  no-gutters
                >
                  <v-col
                    cols="12"
                    class="mt-4"
                    v-if="
                      changeDomainVerification ||
                      (!changeDomainVerification && allRefers.length > 0)
                    "
                  >
                    <v-btn
                      color="primary"
                      height="40px"
                      class="elevation-0"
                      :disabled="!hasEditAllowedDomains"
                      @click="handleAddMultipleModal"
                    >
                      {{ $t('message.pages.folderSettings.addDomains') }}
                    </v-btn>
                  </v-col>
                  <v-col cols="12" class="my-8" v-if="allRefers.length">
                    <v-row no-gutters align="center">
                      <v-col class="shrink mr-1">
                        <v-simple-checkbox
                          class="domainCheckboxColor"
                          :color="!checkboxIndeterminateStatus ? 'primary' : ''"
                          :indeterminate="checkboxIndeterminateStatus"
                          :ripple="false"
                          :value="anyItemSelected"
                          @input="selectAllItems"
                        ></v-simple-checkbox>
                      </v-col>
                      <v-col id="disabledVcol">
                        <v-btn
                          color="error"
                          height="30px"
                          class="px-2 elevation-0 disabledBtnColor"
                          :disabled="
                            !selectedDomains.length ||
                            !hasEditAllowedDomains ||
                            (!changeDomainVerification && allRefers.length > 0)
                          "
                          @click="handleRemoveMultipleModal"
                          >{{
                            $t('message.pages.folderSettings.remove')
                          }}</v-btn
                        >
                        <v-progress-circular
                          v-if="domainsReload"
                          class="ml-2"
                          width="3"
                          size="20"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </v-col>
                      <v-col class="shrink">
                        <v-icon
                          class="mr-1"
                          style="cursor: pointer"
                          @click="manualGetRefers"
                        >
                          mdi-reload
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    v-if="allRefers.length > 0"
                    cols="12"
                    class="mb-6"
                    :data-intro="$t('message.introJS.domain.list')"
                  >
                    <template v-if="allRefers.length">
                      <v-col
                        cols="12"
                        class="ma-0 pa-0 mb-2"
                        v-for="(domain, i) in allRefers"
                        :key="i"
                      >
                        <v-row
                          no-gutters
                          justify="space-between"
                          align="center"
                        >
                          <v-col class="shrink mr-1">
                            <v-simple-checkbox
                              class="domainCheckboxColor"
                              color="primary"
                              :ripple="false"
                              :value="checkIfSelected(domain)"
                              @input="checkboxSelection(domain)"
                            ></v-simple-checkbox>
                          </v-col>
                          <v-col>
                            <v-row no-gutters align="center">
                              <span
                                class="truncateText pr-3 textType-2--text"
                                :title="domain.url"
                              >
                                {{ domain.url }}
                              </span>
                            </v-row>
                          </v-col>
                          <v-col
                            class="shrink align-center"
                            style="white-space: nowrap"
                          >
                            <template
                              v-if="
                                domain.status !== 'active' &&
                                domain.status !== 'inactive'
                              "
                            >
                              <v-progress-circular
                                style="padding-bottom: 2px"
                                class="mr-2"
                                size="17"
                                width="2"
                                indeterminate
                                color="primary"
                              ></v-progress-circular>
                              <span class="textType2--text addingText">
                                {{
                                  domain.status === 'pending'
                                    ? $t(
                                        'message.pages.folderSettings.enabling'
                                      )
                                    : domain.status === 'deleting' ||
                                      (domain.url === beingDeletedDomain.url &&
                                        domain.type === beingDeletedDomain.type)
                                    ? $t(
                                        'message.pages.folderSettings.removing'
                                      )
                                    : $t(
                                        'message.pages.folderSettings.disabling'
                                      )
                                }}
                              </span>
                            </template>
                          </v-col>
                          <v-col cols="12" style="margin-left: 35px">
                            <v-divider class="mt-2" />
                          </v-col>
                        </v-row>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-row
                        no-gutters
                        align="center"
                        justify="center"
                        class="mt-4 flex-column"
                        style="
                          border: 1px solid #e6e8f8;
                          padding-bottom: 56px;
                          padding-top: 48px;
                        "
                      >
                        <v-icon size="50" color="primary">mdi-web</v-icon>
                        <span class="mt-2 noItemsTitle textType--text">
                          {{
                            $t(
                              'message.pages.folderSettings.noneDomainRegistered'
                            )
                          }}
                        </span>
                        <span class="mt-1 noItemsSubtitle textType--text">
                          {{ $t('message.pages.folderSettings.startAdding') }}
                        </span>
                        <v-btn
                          color="primary"
                          height="40px"
                          class="elevation-0 mt-3"
                          @click="handleAddMultipleModal"
                        >
                          {{ $t('message.pages.folderSettings.addDomains') }}
                        </v-btn>
                      </v-row>
                    </template>
                  </v-col>
                </v-row>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </template>
    </template>
  </page-view>
</template>

<script>
// external imports
import { mapMutations } from 'vuex'

// internal imports
import i18n from '@/translations/lang'
import introMixin from '@/utils/intro.mixin.js'

// API
import referApi from '@/services/referApi.js'

// Components
import PageView from '@/layout/PageViewV2.vue'
import LearnMoreBtn from '@/components/LearnMoreBtn.vue'
import ConfirmRemoveDomains from './ConfirmRemoveDomains.vue'
import AddDomains from './AddDomains.vue'

export default {
  name: 'FolderSettings',
  components: {
    PageView,
    LearnMoreBtn,
    BaseHeader: () => import('@/components/BaseHeaderV2.vue'),
    ConfirmRemoveDomains,
    AddDomains,
  },
  mixins: [introMixin],
  data: () => ({
    open: false,
    firstFetch: false,
    isFetchingAdd: false,
    isFetchingDelete: false,
    allRefers: [],
    confirmUser: false,
    changeDomainVerification: false,
    isBeta: false,
    domainVerificationKey: 0,
    articleDomainVerification: '',
    introStarted: false,
    allowDomain: {
      hostname: '',
      type: 'ALLOW',
    },
    blockDomain: {
      hostname: '',
      type: 'BLOCK',
    },
    beingDeletedDomain: {
      url: '',
      type: '',
    },
    userLibrary: {},
    errors: {
      defaultError: false,
      noLibraryError: false,
      invalidHostname: false,
      getRefers: false,
      removeReferValidation: false,
      onAddRefer: false,
      onAddReferDuplicate: false,
      onAddReferAllowedBlank: false,
      onAddReferBlockedBlank: false,
      onDeleteReferDuplicate: false,
      onDeleteRefer: false,
      onDeleteAllowedRefer: false,
      onDeleteBlockedRefer: false,
    },
    unknownErrorMsg: '',
    updateTimeout: null,
    domainsReload: false,
    selectedDomains: [],
    blockNoneRefer: false,
  }),
  computed: {
    anyItemSelected() {
      return this.selectedDomains.length > 0
    },
    checkboxIndeterminateStatus() {
      return (
        this.selectedDomains.length > 0 &&
        this.selectedDomains.length < this.allRefers.length
      )
    },
    hasPendingDomain() {
      return (
        this.allRefers.filter((refer) => refer.status === 'pending').length > 0
      )
    },
    menu() {
      return this.$store.state.user.securityNavItems
    },
    pageMenu() {
      let returnValue = [
        {
          title: 'DRM Watermark',
          to: '/security',
          exact: false,
        },
        {
          title: this.$t('message.routesTitles.Domains'),
          to: '/domains',
          exact: true,
        },
        {
          title: 'Anti-Download',
          to: '/anti-download',
          exact: true,
        },
      ]
      return returnValue
    },
    hasEditAllowedDomains() {
      return (
        this.$store.state.user?.userPermissions?.includes(
          'put-general-config'
        ) ?? false
      )
    },
    allowedDomains() {
      return this.allRefers.filter((refer) => refer.type === 'ALLOW')
    },
    allowedAndPendingDomains() {
      return this.allRefers.filter(
        (refer) => refer.status === 'active' || refer.status === 'pending'
      )
    },
    isAnyDomainChanging() {
      return !!this.allRefers.filter(
        (refer) =>
          refer.status === 'pending' ||
          refer.status === 'deleting' ||
          refer.status === 'turning_inactive'
      ).length
    },
    blockedDomains() {
      return this.allRefers.filter((refer) => refer.type === 'BLOCK')
    },
    onAddReferMsg() {
      if (this.errors.invalidHostname) {
        return i18n.t('message.pages.folderSettings.errors.invalidHostname')
      }
      if (this.errors.onAddReferDuplicate) {
        return i18n.t('message.pages.folderSettings.errors.alreadyExists')
      }
      if (this.errors.onAddReferAllowedBlank) {
        return i18n.t('message.pages.folderSettings.errors.emptyFields')
      }
      if (this.errors.onDeleteAllowedRefer) {
        return i18n.t('message.pages.folderSettings.errors.defaultErrorMsg')
      }
      if (this.errors.onAddRefer) {
        return i18n.t('message.pages.folderSettings.errors.defaultErrorMsg')
      }
      return ''
    },
    onDeleteReferMsg() {
      if (this.errors.onDeleteReferDuplicate) {
        return i18n.t('message.pages.folderSettings.errors.alreadyExists')
      }
      if (this.errors.onAddReferBlockedBlank) {
        return i18n.t('message.pages.folderSettings.errors.emptyFields')
      }
      if (this.errors.onDeleteBlockedRefer) {
        return i18n.t('message.pages.folderSettings.errors.defaultErrorMsg')
      }
      if (this.errors.onDeleteRefer) {
        return i18n.t('message.pages.folderSettings.errors.defaultErrorMsg')
      }
      return ''
    },
  },
  watch: {
    '$store.state.modal.isAnyModalOpen'(val) {
      if (!val && !this.introStarted) {
        this.introStarted = true
        this.setIntroJS({ key: 'domain', delay: 7500 })
      }
    },
    open() {
      const refForm = this.$refs.form
      refForm && refForm.resetValidation()
    },
  },
  mounted() {
    this.isBeta = location.search.match('beta')
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState == 'visible') {
        this.getRefers()
      } else {
        clearInterval(this.updateTimeout)
      }
    })
    this.$root.$emit('changeNavItem', 2)
    this.$root.$on('confirmReferBlock', async (domainVerification) => {
      this.userLibrary.block_none_refer = this.blockNoneRefer =
        domainVerification
      this.changeDomainVerification = this.userLibrary.block_none_refer
      this.domainVerificationKey += 1
      await this.manualGetRefers()
    })
    this.$root.$on('confirmMultipleRemoval', () => {
      this.handleRemoveMultiple()
    })
  },
  created() {
    this.getUserInfos()
  },
  beforeDestroy() {
    this.$root.$off('folderSettingsModal')
    clearInterval(this.updateTimeout)
    this.updateTimeout = null
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    async getUserInfos() {
      this.firstFetch = true
      this.clearErrors()
      await this.getUserLibrary()
      this.changeDomainVerification = this.userLibrary.block_none_refer
      await this.getRefers()
      this.firstFetch = false
    },
    async getUserLibrary() {
      this.clearErrors()
      try {
        let ret = await referApi.getLibrary()
        this.userLibrary = ret.data
        this.blockNoneRefer = ret.data.block_none_refer
      } catch (e) {
        this.errors.noLibraryError = true
      }
    },
    async manualGetRefers() {
      this.domainsReload = true
      await this.getRefers()
      this.domainsReload = false
    },
    async getRefers() {
      this.clearErrors()
      try {
        let ret = await referApi.getRefers(this.userLibrary.id)
        this.allRefers = ret.data.refers.filter(
          (refer) => refer.status != 'inactive'
        )
        clearInterval(this.updateTimeout)
        this.updateTimeout = setInterval(() => {
          if (this.isAnyDomainChanging) {
            this.getRefers()
          }
        }, 10000)
      } catch (e) {
        this.errors.getRefers = true
      }
    },
    async confirmRemoveValidation() {
      this.userLibrary.block_none_refer = this.changeDomainVerification
      this.changeDomainVerification = !this.changeDomainVerification
      this.domainVerificationKey += 1
      this.$root.$emit(
        'enableDomainSecurity',
        this.userLibrary.block_none_refer,
        this.userLibrary.id
      )
    },
    handleGoToArticle() {
      const articleLink =
        this.$i18next.resolvedLanguage === 'pt'
          ? 'https://help.pandavideo.com/pt-br/article/entenda-a-funcionalidade-de-ativardesativar-verificacao-de-dominio-1szfp67/'
          : 'https://help.pandavideo.com/en-us/article/understand-the-functionality-to-enabledisable-domain-verification-works-1h1lwrl/'
      window.open(articleLink, '_blank')
    },
    addDomainsToArray(domains) {
      this.allRefers = this.allRefers.concat(domains)
    },
    async handleAddRefer(domain) {
      this.unknownErrorMsg = ''
      if (domain.type === 'ALLOW' && this.allowDomain.hostname.length < 1) {
        this.errors.onAddReferAllowedBlank = true
        return
      }
      if (domain.type === 'BLOCK' && this.blockDomain.hostname.length < 1) {
        this.errors.onAddReferBlockedBlank = true
        return
      }
      let regex = new RegExp(
        '^(([a-zA-Z0-9]|\\*.[a-zA-Z0-9])([a-zA-Z0-9-_]{0,243}[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,50}$'
      )
      if (!regex.test(domain.hostname)) {
        this.errors.invalidHostname = true
        return
      }
      this.clearErrors()
      this.allRefers.push({
        url: domain.hostname,
        type: domain.type,
        loading: true,
      })
      this.isFetchingAdd = true
      try {
        let ret = await referApi.addRefer(this.userLibrary.id, domain)
        this.allRefers = this.allRefers.map((el) => {
          if (el.url === ret.data.url) {
            if (el.type === ret.data.type) {
              return ret.data
            } else {
              return el
            }
          } else {
            return el
          }
        })
        domain.type === 'ALLOW'
          ? (this.allowDomain.hostname = '')
          : (this.blockDomain.hostname = '')
      } catch (e) {
        this.isFetchingAdd = false
        this.allRefers.pop()
        const anyError = JSON.parse(JSON.stringify(e))
        if (anyError.message.includes('Network Error')) {
          domain.type === 'ALLOW'
            ? (this.errors.onAddReferDuplicate = true)
            : (this.errors.onDeleteReferDuplicate = true)
          this.unknownErrorMsg = 'Code: 500'
          return
        }
        if (e.response.data.errMsg.includes('exists')) {
          domain.type === 'ALLOW'
            ? (this.errors.onAddReferDuplicate = true)
            : (this.errors.onDeleteReferDuplicate = true)
        }
        domain.type === 'ALLOW'
          ? (this.errors.onAddRefer = true)
          : (this.errors.onDeleteRefer = true)
        if (e.response) {
          this.unknownErrorMsg = e.response.err.data.errMsg
        }
      }
      this.isFetchingAdd = false
    },
    handleAddMultipleModal() {
      this.$root.$emit('openAddDomains')
    },
    handleRemoveMultipleModal() {
      this.$root.$emit('openConfirmRemoveDomains', this.selectedDomains)
    },
    async handleRemoveMultiple() {
      let deletedRefers = this.selectedDomains
      for (let deletedRefer of deletedRefers) {
        await this.handleDeleteRefer(deletedRefer)
      }
      this.manualGetRefers()
      this.selectedDomains = []
    },
    async handleDeleteRefer(domain) {
      this.beingDeletedDomain = domain
      this.clearErrors()
      this.isFetchingDelete = true
      try {
        await referApi.removeRefer(this.userLibrary.id, domain.id)
        this.isFetchingDelete = false
        // this.allRefers = this.allRefers.filter((refer) => refer.id != domain.id)
      } catch (e) {
        this.isFetchingDelete = false
        domain.type === 'ALLOW'
          ? (this.errors.onDeleteAllowedRefer = true)
          : (this.errors.onDeleteBlockedRefer = true)
      }
      this.isFetchingDelete = false
      this.beingDeletedDomain = { hostname: '', type: '' }
    },
    clearErrors() {
      Object.keys(this.errors).forEach((e) => (this.errors[e] = false))
    },
    checkIfSelected(item) {
      let foundItem = this.selectedDomains.find((searchedItem) => {
        return searchedItem.id === item.id
      })
      if (foundItem) return true
      return false
    },
    checkboxSelection(item) {
      let alreadySelected = this.checkIfSelected(item)
      if (alreadySelected) {
        let newArr = [
          ...this.selectedDomains.filter((lookFolder) => {
            return lookFolder.id !== item.id
          }),
        ]
        this.selectedDomains = [...newArr]
      } else {
        this.selectedDomains.push(item)
      }
    },
    selectAllItems() {
      if (this.selectedDomains.length === this.allRefers.length) {
        this.selectedDomains = []
        return
      }
      this.selectedDomains = [...this.allRefers]
    },
    handleClose() {
      this.open = false
    },
    initialState() {
      return {
        open: false,
        firstFetch: false,
        isFetchingAdd: false,
        isFetchingDelete: false,
        changeDomainVerification: false,
        domainVerificationKey: 0,
        allRefers: [],
        isBeta: false,
        allowDomain: {
          hostname: '',
          type: 'ALLOW',
        },
        blockDomain: {
          hostname: '',
          type: 'BLOCK',
        },
        beingDeletedDomain: {
          url: '',
          type: '',
        },
        userLibrary: { block_none_refer: false },
        errors: {
          defaultError: false,
          noLibraryError: false,
          invalidHostname: false,
          getRefers: false,
          onAddRefer: false,
          onAddReferDuplicate: false,
          onAddReferAllowedBlank: false,
          onAddReferBlockedBlank: false,
          onDeleteReferDuplicate: false,
          onDeleteRefer: false,
          onDeleteAllowedRefer: false,
          onDeleteBlockedRefer: false,
        },
        unknownErrorMsg: '',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
$size: 1.35rem;

::v-deep .v-slide-group__prev.v-slide-group__prev--disabled {
  display: none !important;
}

::v-deep .page-view__content {
  padding: 28px !important;
}

::v-deep .mdi-help {
  width: 24px !important;
  height: 24px !important;
  font-size: 16px !important;
  background-color: varFigma(neutral-40-light) !important;
}

.domainCheckboxColor {
  .theme--light.v-icon {
    color: #3f55ee;
  }
}
.addingText {
  font-size: 14px;
  font-weight: 400;
  line-height: 150%; /* 21px */
}

.disabledBtnColor.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #ffcdd2 !important;
}

.pageTitle {
  color: varFigma(neutral-20-dark);
  font-family: Rubik;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
}

.helpTexts {
  color: varFigma(neutral-40-light);
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}

.propertiesTitle {
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  line-height: 21px;
  letter-spacing: 0.05em;
}
.noItemsTitle {
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
}
.noItemsSubtitle {
  font-size: 14px;
  font-weight: 400;
  line-height: 150%; /* 21px */
}
.truncateText {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.greyBackground {
  background-color: #6f6f6f;
}

.intro {
  &__btn {
    --intro-background-color: rgba(255, 255, 255, 0.54);
    --intro-foreground-color: #000;
  }
}

.intro {
  &__btn {
    --intro-background-color: var(--v-neutral-lighten1);
    --intro-foreground-color: var(--v-neutral-lighten4);

    position: relative;
    top: 0.5px;

    &::v-deep {
      .v-icon {
        background-color: var(--intro-background-color);
        width: $size;
        height: $size;
        border-radius: 100%;

        &[class*='mdi-'] {
          font-size: $size * 0.8;

          &::before {
            color: var(--intro-foreground-color);
          }
        }
      }
    }
  }
}
.toggle-config-visibility {
  visibility: hidden;
}

@media (min-width: 768px) {
  .helpTexts {
    white-space: pre-line;
  }
}
</style>
